// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fe1f2f01","38":"aba64597","160":"0d445809","208":"71cff2e4","293":"d78723f8","516":"781d5af2","519":"150bb97d","917":"c205b57b","946":"2d8dc0fa"}[chunkId] + ".chunk.js";
};